







import {Component} from 'vue-property-decorator'
import MediaSelector from '@/components/admin/MediaSelector.vue'
import PageBase, {BreadCrumb} from '@/pages/page-base'
@Component({
  components: {
    MediaSelector
  }
})
export default class MediaIndex extends PageBase {
  mounted(): void {
    super.mounted()
  }

  get breadcrumbs(): Array<BreadCrumb> {
    return [
      {
        text: 'メディア一覧'
      }
    ]
  }
}
